import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function TabBar({ value, handleChange }) {
    const { t } = useTranslation(["faq", "common"]);
  
  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
        TabIndicatorProps={{
          style: {
            backgroundColor: "black",
          },
        }}
        sx={{
          ".MuiTab-root": {
            color: "#A6A9AC",
          },
          ".Mui-selected": {
            color: "black !important",
          },
        }}
      >
        <Tab value="worker" label={t("worker")} wrapped />
        <Tab value="company" label={t("company")} />
        <Tab value="supplier" label={t("supplier")} />
        {/* <Tab value="education" label={t("education")} /> */}
        <Tab value="user" label={t("user")} />
        <Tab value="plan" label={t("plan")} />
        <Tab value="package" label={t("package")} />
        <Tab value="gift-card" label={t("giftCard")} />
        <Tab value="event" label={t("event")} />
        <Tab value="user-account" label={t("userAccount")} />
      </Tabs>
    </Box>
  );
}

TabBar.propTypes = {
  value: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default TabBar;
